import { render, staticRenderFns } from "./lojaPerfeitaBandModal.vue?vue&type=template&id=8b2e483c&scoped=true&"
import script from "./lojaPerfeitaBandModal.vue?vue&type=script&lang=js&"
export * from "./lojaPerfeitaBandModal.vue?vue&type=script&lang=js&"
import style0 from "./lojaPerfeitaBandModal.vue?vue&type=style&index=0&id=8b2e483c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2e483c",
  null
  
)

export default component.exports